export default __webpack_public_path__ + "static/media/icon_recruit.b137feea.webp";